import React, { Component } from 'react';
import { connect } from 'react-redux';

import DatePicker from 'material-ui-pickers/DatePicker';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';

// pick utils
import moment from 'moment';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import orange from '@material-ui/core/colors/orange';
import { localStoreFN } from '../../store/localStorage';

const materialTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#f99e60'
      }
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: lightBlue.A200,
        // color: 'white',
      }
    },
    MuiPickersDay: {
      day: {
        //color: orange.A700,
      },
      selected: {
        backgroundColor: '#f99e60'
      },
      current: {
        color: orange['900']
      }
    },
    MuiPickersModal: {
      dialogAction: {
        color: '#f99e60'
      }
    }
  }
});

// sobreescribe metodo para formatear la fecha que se muestra en la cabecera del calendario
class ExtendsMomentUtils extends MomentUtils {
  getDatePickerHeaderText(date) {
    const formatDate = localStoreFN().getItem('formatDate');
    return date.format(formatDate);
  }
}

class DateComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: new Date(),
      style: {
        fontWeight: 'normal',
        //background: '#616161',
        borderRadius: '4px',
        height: 'auto',
        width: '100%'
      }
    };

    // obtiene configuracion del formato de la fecha y lo guarda en localstorage
    localStoreFN().setItem('formatDate', props.language.account.date.format || 'ddd, MMM D');

    // obtiene configuracion del lenguaje para setear el calendario
    this.languageDatePicker = localStoreFN().getItem('lang');
    moment.locale(this.languageDatePicker);
  }

  componentWillMount() {
    const dateformat = moment(this.props.date).format('YYYY-MM-DD');
    const rest = moment(dateformat).utc() + this.props.dif;
    this.setState({ selectedDate: rest });
  }

  handleDateChange = date => {
    this.setState({ selectedDate: date });
    this.props.handleSubmit({
      date: moment(date).format(this.props.language.account.date.format),
      id: this.props.id
    });
  };

  render() {
    return (
      <MuiPickersUtilsProvider utils={ExtendsMomentUtils} locale={this.languageDatePicker} moment={moment}>
        <MuiThemeProvider theme={materialTheme}>
          <div className={`picker ${this.props.containerClassName || ''}`}>
            <DatePicker
              id={this.props.id}
              data-style="date_picker"
              value={this.state.selectedDate}
              onChange={this.handleDateChange}
              style={this.state.style}
              clearable={false}
              autoOk={true}
              leftArrowIcon="<"
              rightArrowIcon=">"
              format={this.props.language.account.date.format}
              cancelLabel={this.props.language.account.accountExtendedProperty.modal.buttonCancel}
              okLabel={this.props.language.account.accountExtendedProperty.modal.buttonOK}
            />
          </div>
        </MuiThemeProvider>
      </MuiPickersUtilsProvider>
    );
  }
}

const mapStateToProps = state => ({
  setting: state.reducer.dashboard.setting,
  language: state.reducer.dashboard.language
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DateComponent);



// WEBPACK FOOTER //
// ./source/client/components/common/dateFilter.jsx